// extracted by mini-css-extract-plugin
module.exports = {"CollapseToggleBar":"Collapse__CollapseToggleBar___no6op","action":"Collapse__action___3kTdP","CollapseBody":"Collapse__CollapseBody___NRzFJ","Hide":"Collapse__Hide___U55Y0"};